<template>
    <SoliResponsiveDialog
        title="Rename Conversation"
        v-if="show"
        @reset="reset()"
        :mobileScroll="false"
    >
        <template #body>
            <v-container>
                <v-form @submit.prevent="submit" v-model="valid">
                    <div class="flex flex-col gap-6">
                        <v-text-field
                            v-model="form.name"
                            autofocus
                            placeholder="Name"
                            outlined
                            dense
                            hide-details="auto"
                        ></v-text-field>
                        <SoliBtn
                            text="Save"
                            icon="save"
                            block
                            gradient="gradient-orange"
                            :loading="form.processing"
                            type="submit"
                        /></div
                ></v-form>
            </v-container>
        </template>
    </SoliResponsiveDialog>
</template>

<script>
export default {
    props: {
        conversation: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            show: true,
            valid: false,
            form: this.$inertia.form({
                name: this.conversation?.name ?? this.conversation.list,
            }),
        };
    },
    methods: {
        submit() {
            this.form.put(route("conversation.update", this.conversation.id), {
                preserveState: false,
                preserveScroll: false,
                onSuccess: () => {
                    this.reset();
                },
                onError: (errors) => {
                    console.log(errors);
                },
            });
        },
        reset() {
            this.show = false;
            this.$emit("reset");
        },
    },
};
</script>
